import axios, { AxiosResponse } from 'axios';

let url = '';

export const initParametersService = (config: Record<string, any>) => {
    url = config.parametersUrl;
};

export const getParameters = async (params?: GetParametersQueryParams) => {
    const res = await axios.get<Parameter[]>(`${url}/parameters`, { params });
    return res.data;
};

export const getParameterById = async (parameterId: string) => {
    const res = await axios.get<Parameter>(`${url}/parameters/${parameterId}`);
    return res.data;
};

export const postNewExpressionParameter = async (newExpression: CreateExpressionParameterRequest[]) => {
    const res = await axios.post(`${url}/parameters/expression`, newExpression);
    return res.data;
};

export const patchExpressionParameter = async (expression: PatchParameterRequest) => {
    const { id, ...rest } = expression;
    const res = await axios.patch<AxiosResponse<Parameter>>(`${url}/parameters/expression/${id}`, rest);
    return res.data;
};

export const deleteParameter = async (data: DeleteParameRequest) => {
    const res = await axios.delete(`${url}/parameters`, { data });
    return res.data;
};

export const postNewVelocityParameter = async (newVelocity: CreateVelocityParameterRequest) => {
    const res = await axios.post(`${url}/parameters/velocity`, newVelocity);
    return res.data;
};

export const patchVelocityParameter = async (patchVelocity: PatchVelocityParameterRequest) => {
    const { id, ...rest } = patchVelocity;
    const res = await axios.patch(`${url}/parameters/velocity/${id}`, rest);
    return res.data;
};

export const getVelocityConfigByRuleSetId = async (ruleSetId: string) => {
    const res = await axios.get<VelocityConfig>(`${url}/parameters/velocity/config/${ruleSetId}`);
    return res.data;
};
